const setStateMutation = (state, payload) => {
    Object.assign(state, payload);
}

const setOperationMutation = (state, payload) => {
    state.operation = payload;
}

const setCategoriesMutation = (state, payload) => {
    const index = state.fields.findIndex(f => f.name === 'category');
    state.fields[index].options = payload;
}

const setMessageMutation = (state, payload) => {
    state.message = payload;
}

const setShowMessageMutation = (state, payload) => {
    state.showMessage = payload;
}

const setLoadingMutation = (state, payload) => {
    state.loading = payload;
}

const mutations = {
    setState: setStateMutation,
    setOperation: setOperationMutation,
    setCategories: setCategoriesMutation,
    setMessage: setMessageMutation,
    setShowMessage: setShowMessageMutation,
    setLoading: setLoadingMutation
}

export default mutations;